import React from 'react';
import { useParams } from 'react-router-dom';
import { Layout } from '../../components/layout/Layout';
import { useGetRoomQuery } from '../../redux/apis/rooms';
import { useGetConfigQuery } from '../../redux/apis/config';
import { usePlayers } from '../../hooks/usePlayers';
import styled from 'styled-components';

const ProgressBar = styled('div')`
  box-sizing: content-box;
  height: 10px;
  position: relative;
  margin: 5px 50px 20px 50px;
  background: #eeeeee;
  border-radius: 9px;
  border: solid 3px #999999;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);

  span {
    display: block;
    height: 100%;
    border-radius: 9px;
    background-color: #54ef9a;
    position: relative;
    overflow: hidden;
    transition: width 0.5s ease-in-out;
  }
`;

export const ProgressBarPanel: React.FC = () => {
  const { roomId } = useParams();
  const getRoom = useGetRoomQuery(roomId!, { skip: roomId === undefined || roomId === ':roomId' });
  const getConfig = useGetConfigQuery(undefined);
  const { players } = usePlayers();

  return getRoom.data?.simpleGame &&
    getRoom.data?.isCreator &&
    getConfig.data?.AdvancePlayersFeature ? (
    <Layout.Panel
      style={{
        margin: '10px',
        maxWidth: '510px',
        position: 'relative',
        padding: '15px',
      }}
    >
      <div
        style={{
          margin: 'auto',
          color: '#999999',
          fontWeight: 400,
          fontSize: '18px',
          textAlign: 'center',
        }}
      >
        Progress
      </div>
      <ProgressBar>
        <span style={{ width: `${(Math.max(...players.map((p) => p.steps)) / 17) * 100}%` }}></span>
      </ProgressBar>
    </Layout.Panel>
  ) : null;
};